import { combineReducers } from "redux";
import { complaints } from "./reducers/complaints";
import { complaint } from "./reducers/complaint";
import { activities } from "./reducers/activities";
import { roles } from "./reducers/roles";
import { urlSearch } from "./reducers/urlSearch";
import { errors } from "./reducers/errors";
import { analytics } from "./reducers/analytics";
import { teamAnalytics } from "./reducers/teamAnalytics";
export const createRootReducer = () => combineReducers({
    complaints,
    complaint,
    activities,
    roles,
    errors,
    urlSearch,
    analytics,
    teamAnalytics,
});
